module.exports = __webpack_public_path__ + "img/4.a3478943.png";